export interface ModalWithParams {
    name: ModalName;
    params?: {
        [key: string]: any;
    };
}

export interface ModalConfig {
    headingText?: string;
    submitBtnText?: string;
}

export type MultipleModalConfigs = Partial<Record<ModalName, ModalConfig>>;

export enum ModalName {
    ADD = "ADD",
    UPDATE = "UPDATE",
    VIEW = "VIEW",
    SETTINGS = "SETTINGS",
}
